import { UserSubscription } from "../entities/UserSubscription";
import { SubscriptionsRepository } from "../repositories/SubscriptionsRepository";

export class GetSubscriptionByUser {
	constructor(private repository: SubscriptionsRepository) {}

	execute(): Promise<UserSubscription> {
		return this.repository.getSubscriptionByUser();
	}
}
